import { CollectionAssetItemModel } from 'src/models/CollectionModel';
import { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import JustifiedGallery from '../gallerySearch/JustifiedGallery';
import { AssetPublishModel } from 'src/models/assetModel';
import { AssetType } from 'src/constant/assetConstants';
import { ExtendedLicenseModel, StandardLicenseModel } from 'src/models/LicenseModel';
import { StandardLicense } from 'src/constant/licenseConstants';

interface TypeInterface {
  assetCollectionItems: CollectionAssetItemModel[];
}

export default function GalleryCollection({ assetCollectionItems }: TypeInterface) {
  const [assets, setAssets] = useState<AssetPublishModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (assetCollectionItems) {
      onSetAssetPublishModel();
    }
  }, [assetCollectionItems]);

  const onSetAssetPublishModel = () => {
    setIsLoading(true);

    try {
      const assetsInCollection: AssetPublishModel[] =
        assetCollectionItems
          .map<AssetPublishModel>((item) => ({
            id: item.asset.id,
            assetType: item.asset.assetType,
            code: item.asset.code!,
            name: item.asset.name,
            description: item.asset.description!,
            thumbnailImageUrl: item.asset.thumbnailImageUrl!,
            thumbnailVideoUrl: item.asset.thumbnailVideoUrl!,
            thumbnailVideoCoverUrl: item.asset.thumbnailVideoCoverUrl!,
            hasSMLicense: item.asset.hasSMLicense,
            hasXLLicense: item.asset.hasXLLicense,
            hasHDLicense: item.asset.hasHDLicense,
            hasUHDLicense: item.asset.hasUHDLicense,
            publishDate: new Date(),
            hasCollection: false,
            keywords: item.asset.keywords!,
            userId: '',
            artistFirstname: item.asset.artistFirstname,
            artistLastname: item.asset.artistLastname,
            artistNameEn: item.asset.artistNameEn,
            standardLicense: {
              id: 'string',
              assetType: AssetType.IMAGE,
              code: StandardLicense.SM,
              name: 'string',
              price: 0,
              sequence: 0,
            } as StandardLicenseModel,
            extendedLicense: {
              id: 'string',
              assetType: AssetType.IMAGE,
              code: StandardLicense.SM,
              name: 'string',
              price: 0,
              liftTimeType: 0,
              liftTime: 0,
              sequence: 0,
            } as ExtendedLicenseModel,
            price: 0,
            isDisabled: false,
            isHasLicense: false,
            imageOrientation: item.asset.imageOrientation ?? item.asset.orientation,
            orientation: item.asset.orientation,
            width: item.asset.width,
            height: item.asset.height,
          }));

      setAssets(assetsInCollection);
    } catch (error) {
      setAssets([]);
      console.error('Error setting asset publish model:', error);
    } finally {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      setIsLoading(false);
    }
  };

  return (
    <>
      {
        isLoading
          ? <Skeleton.Image active />
          : <JustifiedGallery assets={assets} />

      }
    </>
  );
}